import { AppRemixIcon, AppSingleSelect } from '@/layout/AppComponents';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { axiosPath } from '../../../../routing/helpers/router';
import Translator from '../../helpers/Translator';
import useIsMounted from '../../hooks/useIsMounted';
import errorHandler from '../../error/ErrorHandler';

export default function SelectParentPlantGroupFolder(props) {
  const {
    value,
    onHandleChange,
    error,
    title = <Translator file="user" name="module.plantGroups" />,
    className = 'mb-2',
    isMulti = false,
    hasSearchBox = false,
    hasSelectOptions = false,
    isClearable = false,
    isDisabled = false,
    required = false,
  } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [options, setOptions] = useState(null);

  // > LOAD PLANT GROUP FOLDERS WITH FOLDER CHILDREN
  const loadPlantGroups = useCallback(
    async () =>
      axios
        .get(axiosPath('api_r_user_global_getPlantGroupFoldersWithFolderChildren'))
        .then(({ data }) => {
          if (isMounted.current) setOptions(data);
        })
        .catch((e) => dispatch(errorHandler(e))),
    []
  );

  useEffect(() => {
    loadPlantGroups();
  }, []);
  // < LOAD PLANT GROUP FOLDERS WITH FOLDER CHILDREN

  return (
    <AppSingleSelect
      options={options}
      title={title}
    //   onChange={(opt) => onHandleChange(transformOptions(opt))}
      onChange={(opt) => onHandleChange(opt)}
      icon={<AppRemixIcon icon="folder" />}
      isLoading={!options}
      value={value}
      error={error}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
      isDisabled={isDisabled}
      required={required}
    />
  );
}
